import { store } from '~/store';

export const isLoggedIn = () => {
  const state = store.getState();
  return state.currentAccount.id ? true : false;
};
